import create, { GetState, SetState } from "zustand";
import { persist } from "zustand/middleware";

import createCalculatorSlice, { CalculatorSlice } from "./createCalculatorSlice";
import createDokumentasiUISlice, { DokumentasiUISlice } from "./createDokumentasiUISlice";
import createMainSlice, { MainSlice } from "./createMainSlice";
import createOrderSlice, { OrderSlice } from "./createOrderSlice";
import createSessionSlice, { SessionSlice } from "./createSessionSlice";
import createShippingSlice, { ShippingSlice } from "./createShippingSlice";
import createRegionSlice, { RegionSlice } from "./regionSearch";

export type StoreState = MainSlice &
  SessionSlice &
  OrderSlice &
  ShippingSlice &
  CalculatorSlice &
  DokumentasiUISlice &
  RegionSlice;
export type CreateSlice<T = any> = (set: SetState<StoreState>, get: GetState<StoreState>) => T;

export const useStore = create<StoreState>(
  persist(
    (set, get) => ({
      ...createMainSlice(set, get),
      ...createSessionSlice(set, get),
      ...createOrderSlice(set, get),
      ...createShippingSlice(set, get),
      ...createCalculatorSlice(set, get),
      ...createDokumentasiUISlice(set, get),
      ...createRegionSlice(set, get),
    }),
    {
      name: "main-storage",
      whitelist: [
        "selectedCabang",
        "selectedAddress",
        "selectedOrder",
        "noTransaksi",
        "selectedJenisPakaian",
        "selectedOrderTab",
        "catatan",
        "courierName",
      ],
      version: 4,
    },
  ),
);

export default useStore;
